import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const Tag = ({ item, content, deleteFunction }) => {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        background: "#e8f0fe",
        color: "#1a73e8",
        border: "1px solid #c5d8fb",
        borderRadius: "20px",
        padding: "4px 12px",
        fontSize: "0.82rem",
        fontWeight: 500,
        marginRight: "6px",
        marginBottom: "6px",
      }}
    >
      <span>{content}</span>
      {deleteFunction ? (
        <button
          type="button"
          onClick={() => deleteFunction(item)}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "#c62828",
            padding: 0,
            display: "flex",
            alignItems: "center",
            fontSize: "0.72rem",
            lineHeight: 1,
          }}
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      ) : null}
    </div>
  );
};

export default Tag;
